export default __webpack_public_path__ + "static/media/Group4.85af8bd4.svg";